import type { AssetQaRunViewDto } from '@/types/assetQa'

/**
 * How much a run still owes (ORB-987).
 *
 * ⚑ Here rather than inline because two surfaces now print it — the panel's own "N to fix" and the
 * collapsed section header's `Quality check (N)` — and a panel saying 3 under a header saying 4 is
 * the exact failure the QA chip's own comment warns about. One definition, so they cannot drift.
 */

/**
 * Open findings only. Fixed, Overridden and False Positive are all settled, and counting "not
 * Overridden" as outstanding would make the number disagree with the verdict beside it.
 *
 * ⚑⚑ Findings only — never plus unverified checks. A finding is something wrong; an unverified check
 * is something nobody could confirm. One number covering both would be a false pass dressed up as a
 * count, which is what the rulebook's three-status rule exists to prevent. The coverage gap is
 * carried by the verdict pill, which the matrix already requires to list what a person still has to
 * check.
 */
export function countOpenFindings(run: AssetQaRunViewDto | null): number {
    if (!run) return 0
    return run.Findings.filter(finding => finding.Status === 'Open').length
}
